// Spinner-rack comic hover — modal kind. Comics rotating on a vintage
// newsstand spinner; hovering one outlines it + makes it E-eligible.
// Disabled entirely while the rack is mid-spin (state !== 'none') because
// the comics are moving and a hover would be visually noisy.

import { registerInteractable } from "../_interactable-registry.js";
import { addOutline, removeOutline } from "../helpers.js";

registerInteractable({
	id: "spinner-rack",
	precedence: 70,
	// ASK-137 §84 — THIS KIND'S OWN PROMPT AND SUBJECT. `stage.js` used to enumerate every kind by
	// hand, twice (`_updateEHint`'s hover ladder and `_hoveredProduct`), which is exactly what the
	// registry's own header says a registry exists to end. The prompt a shopper reads and the product
	// it names belong where the rest of this kind's behaviour already is.
	hoverHint: '<kbd>E</kbd> Inspect &nbsp;·&nbsp; <kbd>←→</kbd> Spin',
	productOf(stage, active) {
		return active?.product ?? stage.spinnerRack?.hoveredComic?.product ?? null;
	},

	suppressedBy(stage) {
		// Box modal / hero claims always win.
		if (stage.boxState === "open" || stage.boxState === "browsing" || stage.boxState === "hero") return true;
		if (stage.activeFixtureHero) return true;
		if (stage.activeVinylBin)    return true;
		if (stage.activeStackTable)  return true;
		// No rack, or rack is mid-animation.
		if (!stage.spinnerRack)                       return true;
		if (stage.spinnerRack.state !== "none")       return true;
		if (!stage.spinnerRack.comics?.length)        return true;
		return false;
	},

	getTargets(stage) {
		return stage.spinnerRack.comics.map((c) => c.mesh);
	},

	onHit(stage, mesh) {
		return stage.spinnerRack.comics.find((c) => c.mesh === mesh) ?? null;
	},

	commitHover(stage, prev, next) {
		if (prev?.mesh && prev !== next) removeOutline(prev.mesh);
		if (stage.spinnerRack) stage.spinnerRack.hoveredComic = next;
		if (next?.mesh && prev !== next) addOutline(next.mesh);
	},

	interactE(stage, active) {
		if (!active || !stage.spinnerRack || stage.spinnerRack.state !== "none") return false;
		stage.setSpinnerHero(active);
		return true;
	},
});
